import React from "react";
import BusinessIcon from "@mui/icons-material/Business";
import LaunchIcon from "@mui/icons-material/Launch";

interface BusinessDetailsCardProps {
  businessName: string;
  email: string;
  phoneNumber: string;
  yearsOfOperation: string;
  physicalAddress: string;
  city: string;
  stateProvince: string;
  zipPostalCode: string;
  country: string;
  businessHoursOpen: string;
  businessHoursClose: string;
  isRegistered: string;
  rcNumber: string;
  onClickAction?: () => void;
  account_name: string;
  account_number: string;
  bank_name: string;
  showImportant: boolean;
}

const BusinessDetailsCard: React.FC<BusinessDetailsCardProps> = ({
  businessName,
  email,
  phoneNumber,
  yearsOfOperation,
  physicalAddress,
  city,
  stateProvince,
  zipPostalCode,
  country,
  businessHoursOpen,
  businessHoursClose,
  isRegistered,
  rcNumber,
  onClickAction,
  account_name,
  account_number,
  bank_name,
  showImportant,
}) => {
  console.log(showImportant)
  return (
    <div className="flex flex-col gap-8">
      <div className="bg-white rounded-xl p-6 shadow-sm">
        <div className="flex items-center gap-2 mb-6">
          <BusinessIcon className="text-gray-700" />
          <h2 className="text-lg font-semibold text-gray-900">
            Business Details
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Business Name
            </label>
            <input
              type="text"
              value={businessName}
              disabled
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Email Address
            </label>
            <input
              type="email"
              value={email}
              disabled
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Phone Number
            </label>
            <input
              type="tel"
              value={phoneNumber}
              disabled
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Years of Operation
            </label>
            <input
              type="text"
              value={yearsOfOperation}
              disabled
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>

          <div className="md:col-span-2">
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Physical Business Address
            </label>
            <input
              type="text"
              value={physicalAddress}
              disabled
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              City
            </label>
            <input
              type="text"
              value={city}
              disabled
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              State/Province
            </label>
            <input
              type="text"
              value={stateProvince}
              disabled
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              ZIP/Postal Code
            </label>
            <input
              type="text"
              value={zipPostalCode}
              disabled
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Country
            </label>
            <input
              type="text"
              value={country}
              disabled
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Business Hours (Open)
            </label>
            <input
              type="text"
              value={businessHoursOpen}
              disabled
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Business Hours (Close)
            </label>
            <input
              type="text"
              value={businessHoursClose}
              disabled
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Is your Business Registered?
            </label>
            <input
              type="text"
              value={isRegistered}
              disabled
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              RC Number
            </label>
            <input
              type="text"
              value={rcNumber}
              disabled
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>
        </div>
      </div>
      <div className="bg-white rounded-xl p-6 shadow-sm">
        <div className="flex items-center justify-between w-full">
          <div>
            <div className="flex items-center gap-2 mb-6">
              <BusinessIcon className="text-gray-700" />
              <h2 className="text-lg font-semibold text-gray-900">
                Bank Details
              </h2>
            </div>
            Enter your bank details here
          </div>
          <div className={showImportant ? '' : 'hidden'} >
            <LaunchIcon
              fontSize="small"
              className={`text-gray-600 `}
              onClick={onClickAction}
            />
          </div>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Bank Name
            </label>
            <input
              type="text"
              value={bank_name}
              disabled
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Account Name
            </label>
            <input
              type="text"
              value={account_name}
              disabled
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-900 mb-2">
              Account Number
            </label>
            <input
              type="text"
              value={account_number}
              disabled
              className="w-full px-4 py-2.5 border border-gray-200 rounded-lg bg-gray-50 text-gray-700"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BusinessDetailsCard;
